import styled from 'styled-components';

export const ProgressBarWrapper = styled.div`
  .legend-progress {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 5px;

    h5,
    span {
      color: var(--primary-color);
      text-transform: uppercase;
      font-family: 'Inter';
      font-size: var(--font-small);
      font-weight: 400;
    }
  }

  .progress-bar {
    background-color: var(--color-progress-background);
    height: 9px;
    border-radius: 5px;
    width: 100%;

    div {
      background-color: var(--primary-color);
      border-radius: 5px;
      height: 8px;
    }
  }
`;
